import React from 'react';
import { Field, CccisdWysiwyg } from 'cccisd-formik';
import { widgetBuilder } from 'cccisd-laravel-appdefs';

export const initialValues = {
    title: 'Footnotes',
    footnotes: '',
};

const Component = props => {
    return (
        <div>
            <Field name="title" component={CccisdWysiwyg} label="Page Title" />
            <Field name="footnotes" component={CccisdWysiwyg} label="Footnotes" />
        </div>
    );
};

export default widgetBuilder({ initialValues })(Component);
